import React from 'react';
import { Switch, Route } from 'react-router-dom';

import HomePrincipal from '../pages/Home';
import SaoPauloPage from '../pages/SaoPauloPage';
import BeloHorizontePage from '../pages/BeloHorizontePage';
import PremiacoesSPPage from '../pages/PremiacoesSPPage';
import PremiacoesBHPage from '../pages/PremiacoesBHPage';
import Vote from '../pages/Vote';
import VerifyEmail from '../pages/VerifyEmail';
import LoginGoogle from '../pages/LoginGoogle';
import LoginFacebook from '../pages/LoginFacebook';
import NotFound from '../pages/NotFound';

const Routes = () => {
  return (
    <Switch>
      <Route
        path={['/', '/termos-de-uso', '/lgpd']}
        component={HomePrincipal}
        exact
      />

      <Route
        path={[
          '/sao-paulo',
          '/sao-paulo/termos-de-uso',
          '/sao-paulo/lgpd',
          '/sao-paulo/padaria/:slug'
        ]}
        component={SaoPauloPage}
        exact
      />

      <Route
        path={[
          '/belo-horizonte',
          '/belo-horizonte/termos-de-uso',
          '/belo-horizonte/lgpd',
          '/belo-horizonte/padaria/:slug'
        ]}
        component={BeloHorizontePage}
        exact
      />

      <Route path="/premiacoes-sp" component={PremiacoesSPPage} exact />
      <Route path="/premiacoes-bh" component={PremiacoesBHPage} exact />

      <Route path="/votacao/:tema" component={Vote} exact />

      <Route path="/email/verificar/:hash" component={VerifyEmail} exact />

      <Route path="/login/google/callback" component={LoginGoogle} exact />
      <Route path="/login/facebook/callback" component={LoginFacebook} exact />

      <Route component={NotFound} />
    </Switch>
  );
};

export default Routes;
